import React, {useEffect} from 'react';
import {View} from 'react-native';
import {useTheme} from 'contexts/ThemeContext';
import styleSheet from './styles';
import {observer} from 'mobx-react';
import {useConferenceStore} from 'contexts/StoreContext';
import ChatList from 'components/organisms/chatList';
import {ChatScreenProps} from 'navigations/HomeFlow';

const ChatScreen = observer((props: ChatScreenProps) => {
  const theme = useTheme();
  const styles = styleSheet(theme);

  const chatStore = useConferenceStore().chatStore;

  useEffect(() => {
    chatStore.setHasUnreadMessages(false);
  }, [chatStore.chatMessages]);

  return (
    <View style={styles.container}>
      <ChatList
        message={chatStore.message}
        setMessage={chatStore.setMessage}
        onPressSend={chatStore.sendMessage}
        chatMessages={chatStore.chatMessages}
      />
    </View>
  );
});

export default ChatScreen;
